module.exports = __webpack_public_path__ + "img/zhengshu5.db30111d.png";